import { createAction, props } from '@ngrx/store';

export const showSpinner = createAction(
  '[Common] Show Spinner',
  props<any>()
);

export const hideSpinner = createAction(
  '[Common] Hide Spinner',
  props<any>()
);

export const navigationStart = createAction(
  '[Common] Navigation To Page Start',
  props<any>()
);

export const navigationEnd = createAction(
  '[Common] Navigation To Page End',
  props<any>()
);

